import { initRatingForm, initUsefulRatingVote } from 'Functions/rating';
import { initAnchors } from 'Functions/anchor';
import Swiper, { Pagination, Navigation } from 'swiper';

import { Vue, i18n } from 'Common/vue';
import BranchReservation from 'VueComponents/BranchReservation/BranchReservation';
import BranchReservationStore from 'VueComponents/BranchReservation/_store';

import 'Layouts/default';

import 'Ui/slider';
import 'Ui/tabs';
import 'Ui/more-items';
import 'Ui/favorite-trigger';
import 'Ui/star-rating';

import 'Common/lightgallery';

import 'Components/seen-products';
import 'Components/modal/modal-remote';
import 'Components/modal/modal-watchdog';

Swiper.use([Pagination, Navigation]);

const $ = window.jQuery;

initAnchors()
initRatingForm()
initUsefulRatingVote()

const branchReservationEl = document.querySelector('.vue-branch-reservation')
if (branchReservationEl) {
    window.$_branchReservation = new Vue({
        i18n: i18n,
        store: BranchReservationStore,
        render: (h) => h(BranchReservation)
    }).$mount(branchReservationEl);

    $('#product-reservation').on('show.bs.modal', function() {
        BranchReservationStore.dispatch('initReservation')
    })
}